<template>
	<div class="col-xs-12 col-sm-12 col-md-12">
		<nav class="navbar navbar-default">

			<div class="navbar-header">
				<div class="navbarColumn">
					<div class="navbarColumn__col1">
						<h1 class="siteLogo"><a v-link="{ path: '/', exact: true }"><img src="/static/images/pageHeader/pp_logo.png" alt="studio DATA BASE"></a></h1>
						<p class="catchCopy hidden-xs">"プロ" のためのレンタル撮影スタジオ検索サイト</p>
					</div>
					<div class="navbarColumn__col2 visible-xs">
						<template v-if="isPageFlg">
						<button v-on:click="accordion" type="button" class="toggle_search js-accordionGroup" data-toggle="collapse" data-target="#searchBlock">
							<span class="sr-only">検索</span>
							<span class="glyphicon glyphicon-search"></span>
						</button>
						</template>
						<button v-on:click="accordion" type="button" class="navbar-toggle js-accordionGroup" data-toggle="collapse" data-target="#globalNav">
							<span class="sr-only">メニュー</span>
							<span class="icon-bar"></span>
							<span class="icon-bar"></span>
							<span class="icon-bar"></span>
						</button>
					</div>
				</div>
			</div>

			<div id="globalNav" class="navbar-collapse collapse">
				<ul class="nav navbar-nav">
					<li><a href="//studio.powerpage.jp/contents/category/studiorepo" target="_blank">スタジオルポ</a></li>
					<li><a href="//studio.powerpage.jp/contents/category/feature" target="_blank">特集</a></li>
					<li><a href="//studio.powerpage.jp/contents/advertise" target="_blank">広告掲載について</a></li>
					<li><a href="//studio.powerpage.jp/contents/terms" target="_blank">このサイトについて</a></li>
					<li v-if="wwidth > 767"><a v-link="{ path: '/favorites' }" target="_self">お気に入り</a></li>
					<li v-else><a v-link="{ path: '/favorites' }" data-toggle="collapse" data-target="#globalNav">お気に入り</a></li>
					<li><a href="https://www.facebook.com/studio.powerpage.jp" target="_blank"><img src="/static/images/pageHeader/fb.png" width="20px" alt="Facebook"></a></li>
					<li><a href="https://twitter.com/studio_database" target="_blank"><img src="/static/images/pageHeader/x.png" width="18px" alt="X"></a></li>
				</ul>
			</div>

		</nav>
	</div>
</template>

<script>
module.exports = {
	props: {
		wwidth: ''
	},
	data: function(){
		return {
			expanded: ''
		};
	},
	created: function(){
	},
	ready: function(){
		// console.log(this.isPage);
	},
	computed: {
		isPageFlg: function(){
			return this.$route.isPage;
		}
	},
	methods: {
		accordion: function(e){
			var group = document.getElementsByClassName('js-accordionGroup');
			var self = {
				target: e.currentTarget.getAttribute('data-target'),
				ae: e.currentTarget.getAttribute('aria-expanded')
			};

			for (var i = 0; i < group.length; i++){
				var target = group[i].getAttribute('data-target');
				var ae = group[i].getAttribute('aria-expanded');
				if (self.target !== target){
					if (self.ae !== 'true' && ae === 'true'){
						$(target).collapse('hide');
					}
				}
			}
		},
		toggleAS: function(e){
			var self = e.currentTarget;
			var expanded = self.getAttribute('aria-expanded');
			if (expanded === 'true'){
				// console.log('close');
			} else {
				// console.log('open');
				this.smoothScroll('body');
			}
		}
	},
	mixins: [
		require('../mixins/smoothScroll.js')
	]
};
</script>

<style scoped lang="scss">
// .hidden{
// 	display: none;
// }
</style>



// WEBPACK FOOTER //
// nav.vue?295fe7f4